@if ({ memberships: filterSet$ | async }; as state) {
  @if (!!activeMembership && membershipsWithAdminAccess.length > 1) {
    <button
      tid="organisation-menu-button"
      [matMenuTriggerFor]="organisationMenu"
      class="menu-trigger"
      tabindex="0"
      (click)="focusSearch()"
      #orgOpener
    >
      <span>{{ activeMembership.organisationName }}</span>
      <i class="ph-light ph-caret-down"></i>
    </button>
    <form [formGroup]="formGroup">
      <mat-menu
        #organisationMenu
        tid="organisation-menu"
        class="context-menu"
        style="width: 32rem"
        backdropClass="organisation-menu-backdrop"
        xPosition="after"
        yPosition="below"
        [overlapTrigger]="false"
      >
        @if (state.memberships) {
          <app-search-input
            class="org-searcher"
            #searchInput
            formPropertyName="searchTerm"
            (click)="$event.stopPropagation()"
            (keydown)="$event.stopPropagation()"
            [autocomplete]="'off'"
            placeholder="Search"
            tabindex="0"
            [forContextMenu]="true"
          ></app-search-input>
          @for (membership of state.memberships; track membership) {
            <button mat-menu-item (click)="changeOrg(membership)" tabindex="0">
              {{ membership.organisationName }}
            </button>
          }
          @if (state.memberships.length === 0) {
            <app-body-md [bold] id="no-results">No organisations found </app-body-md>
          }
        }
      </mat-menu>
    </form>
  }
  @if (!!activeMembership && membershipsWithAdminAccess.length === 1) {
    <div class="selected-label" tid="single-membership-label">
      <span>{{ activeMembership.organisationName }}</span>
    </div>
  }
}
